angular.module('PatientApp').controller('MyChartSSOCtrl', function($scope, $rootScope, $filter, $state){
    
    var _reset = function() {
        // attach this on an obj so 
        // ng-include doesnt attach data to
        // a child scope
        $scope.findData = {};
    };

    _reset();

    // initial state
    $scope.showingCheckEmail = false;
    $scope.showingEmailVerify = false;
    $scope.showingNoBills = false;

    $scope.acceptTerms = false;
    $scope.email = '';

    $scope.patientUserWithEmailExists = false;

    // listeners
    $rootScope.$on('myChartSSO:showCheckEmail', function() {
        $scope.showingCheckEmail = true;
    });

    $rootScope.$on('myChartSSO:showNoBills', function() {
        $scope.showingNoBills = true;
    });

    // functions
    $scope.checkForPatientWalletAccount = function() {
        var patientUserExists = false;
        $scope.patientUserWithEmailExists = patientUserExists;
        if (patientUserExists) {
            $scope.verifyEmailPrompt = $filter('translate')('myChartSSO.verifyEmail.promptPatientUserExists', { email: $scope.email });
        } else {
            $scope.verifyEmailPrompt = $filter('translate')('myChartSSO.verifyEmail.promptPatientUserDoesNotExist', { email: $scope.email });
        }

        $scope.showingCheckEmail = false;
        $scope.showingEmailVerify = true;
    };

    $scope.verifyEmail = function() {
        $scope.showingEmailVerify = false;
        $scope.$emit('simpleModal:showPrompt', {
            header: 'Welcome to your PatientWallet',
            subcontent: 'yay you did it',
            intent: 'success',
            actions: [{
                label: $filter('translate')('actions.continue'),
                includeClasses: 'continue-button',
                clickHandler: function(){
                    $state.go('app.dashboard');
                }
            }]
        });
    };

    // calculated values
    $scope.welcomeMessage = $filter('translate')('myChartSSO.welcomeToPatientWallet', { providerGroupName: 'Medical Group of America' });  // TODO: Don't hardcode
    $scope.verifyEmailPrompt = '';
    $scope.noBillsPrompt = $filter('translate')('myChartSSO.noBillsPrompt', { patientName: 'Jane Doe' });
});
